<template>
  <!-- 标签 -->
  <!-- <div class="new-msgItem-badge" ></div> -->
  <div class="img_container_p">
    <div class="img_container">
      <!-- <div v-if="index > 36666" class="image_cover">离线</div> -->
      <img class="uImage img" :src="msgItem.avatar || '@/assets/img/uimg/img-avatar01.jpg'"
        @click="showUinfoLayer(msgItem, $event)" />
    </div>
    <!-- <em class="m_vui__badge" v-if="msgItem.id !== selectedAccountId && msgItem.new_msg_count > 0">{{ msgItem.new_msg_count }}</em> -->
    <em class="m_vui__badge" v-if="msgItem.new_msg_count > 0">{{
      msgItem.new_msg_count
    }}</em>
  </div>

  <div class="info_container overflow_ellipsis">
    <div style="display: flex; flex-direction: column">
      <div class="c1 flex_center" style="flex: 1">
        <div class="icon_item">
          <el-tooltip class="box-msgItem" effect="light" placement="top-start">
            <template #content>
              <div style="width: 200px; min-height: 50px">
                <div v-if="msgItem.end_flg == -1">
                  端口信息： <span class="m_color_e">端口未绑定</span>
                  <div class="m_color_e">
                    请联系管理员尽快绑定端口，否则无法正常使用功能
                  </div>
                </div>
                <div v-else>
                  <div>
                    端口信息：
                    <span v-if="msgItem.expire_day >= 30">正常</span>
                    <span v-else-if="msgItem.expire_day > 0" class="m_color_w">即将过期</span>
                    <span v-else class="m_color_e">端口已过期</span>
                  </div>
                  <div>端口号：【{{ msgItem.port_id }}】</div>
                  <div>端口过期时间：{{ msgItem.expire_time }}</div>
                  <div>
                    有效天数：
                    <span v-if="msgItem.expire_day < 0">0</span>
                    <span v-else>{{ msgItem.expire_day }}</span>
                  </div>

                  <div v-if="msgItem.expire_day < 30" class="m_color_e">
                    请联系管理员尽快续费端口号，否则端口过期后无法正常使用功能。
                  </div>
                </div>
              </div>
            </template>
            <div>
              <i class="iconfont icon-anquanbaozhang-xianxing m_color_s22" v-if="msgItem.expire_day >= 30"></i>
              <i class="iconfont icon-anquanbaozhang-xianxing m_color_w" v-else-if="msgItem.expire_day > 0"></i>
              <i class="iconfont icon-anquanbaozhang-xianxing m_color_e" v-else></i>
            </div>
          </el-tooltip>
        </div>

        <div v-if="msgItem.use_robot === 1" class="icon_item">
          <el-popover placement="top-start" width="200" trigger="hover">
            <div style="min-height: 50px; font-size: 12px">
              <div class="m_desc m_border_b" style="margin-bottom: 10px">
                账号的AI客服接管开启后，AI会自动回复此账号下可会话客户的对话。
              </div>
              <div v-if="msgItem.use_robot_status === 1">
                AI客服状态： <span class="m_color_s2">开启</span>
              </div>
              <div v-else>AI客服状态： <span class="m_color_e">关闭</span></div>
              <div>
                AI客服：<span class="m_desc">{{ msgItem.robot_name }}</span>
              </div>
              <div>
                AI客服接管:
                <el-switch v-model="msgItem.use_robot_status" size="small" active-text="" inactive-text=""
                  :active-value="1" :inactive-value="0" @change="handleUseRobotStatusChange(msgItem)" />
              </div>
            </div>
            <template #reference>
              <i class="iconfont icon-zhinengkefuzhongxin" :class="{ m_color_s22: msgItem.use_robot_status === 1 }"></i>
            </template>
          </el-popover>
        </div>

        <i class="iconfont icon-xiaohongshu m_color_e1"></i>
        <span class="m_color_2" style="margin-left: 3px">
          {{msgItem.username}}
        </span>
        <div class="m_border_r m_desc overflow_ellipsis" style="margin-left: 3px; font-size: 11px; padding: 0 3px">
          {{
            $syscfgNameByValue("customer_type_list", msgItem.customer_type_id)
          }}
        </div>
      </div>
    </div>
    <!-- <div class="r2">
              
              </div> -->
  </div>
</template>


<script>
import { computed, onMounted, ref, watch } from "vue";
export default {
  props: { item: { type: Object } },
  emits: ["showAccountInfo", 'changeAiStatus'],
  setup(props, { emit }) {
    // -------------- 属性 ----------------
    // setup() 接收 props 作为第一个参数
    const msgItem = computed(() => {
      return props.item;
    });

    // --------------- 方法 --------------
    const handleUseRobotStatusChange = (rowItem) => {
      emit("changeAiStatus", rowItem);
    };

    const showUinfoLayer = (rowItem, e) => {
      console.log("--------------------");
      let pos = [e.clientX, e.clientY];
      emit("showAccountInfo", { rowItem, pos });
      e.stopPropagation();
    };
    return {
      msgItem,
      showUinfoLayer,
      handleUseRobotStatusChange,
    };
  },
};
</script>

<style lang="scss" scoped>
.img_container_p {
  position: relative;

  .m_vui__badge {
    position: absolute;
    top: -5px;
    right: -5px;
    z-index: 998;
  }

  .img_container {
    width: 30px;
    height: 30px;
    overflow: hidden;
    border-radius: 100%;
    position: relative;
    margin-left: 10px;

    .img {
      object-fit: fill;
      width: 30px;
      height: 30px;
    }

    .image_cover {
      z-index: 11;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .8);
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      color: white;
    }
  }
}

.info_container {
  box-sizing: border-box;
  margin: 5px 5px;
  display: flex;
  align-items: center;

  .c1 {
    .icon_item {
      margin-right: 3px;
    }
  }

}
</style>